import {
  DeactivateOfferInput,
  DeactivateOfferResult,
} from '@varo/graphql-schema-types';
import DeactivateOffer from 'services/graphql/mutations/Rewards/DeactivateOffer';
import useCancellableMutation from 'shared/hooks/useCancellableMutation';

interface DeactivateOfferMutationData {
  deactivateOffer: DeactivateOfferResult;
}

interface DeactivateOfferVariables {
  input: DeactivateOfferInput;
}

const useDeactivateOffer = () => {
  const [{ data, fetching, error }, executeMutation] = useCancellableMutation<
    DeactivateOfferMutationData,
    DeactivateOfferVariables
  >(DeactivateOffer);

  return {
    fetching,
    deactivateOffer: executeMutation,
    data,
    error,
  };
};

export default useDeactivateOffer;
